import { z } from 'zod';
/**
 * Nachmeldungen des Fahrers zu einer abgeschlossenen Fahrt (KON-264). Der Fahrer meldet, was erst nach dem Abschluss feststeht: zusätzliche Kilometer (Umweg, Zusatzfahrt), zusätzliche
 * Wartezeit in Minuten oder eine Notiz zum Ablauf. Das Büro sieht die Meldungen am Auftrag, rechnet nach und markiert sie als erledigt.
 */
export const RIDE_REPORT_KINDS = ['extra_km', 'waiting', 'note'];
export const RIDE_REPORT_LABELS = {
    extra_km: 'Zusätzliche Kilometer',
    waiting: 'Zusätzliche Wartezeit',
    note: 'Notiz',
};
export const RIDE_REPORT_UNITS = { extra_km: 'km', waiting: 'min', note: null };
export const createRideReportInput = z
    .object({
    kind: z.enum(RIDE_REPORT_KINDS, 'Bitte die Art der Meldung wählen'),
    /** Kilometer oder Minuten, bei einer Notiz weggelassen */
    quantity: z.number('Bitte eine Zahl angeben').positive('Der Wert muss größer als 0 sein').max(9999, 'Höchstens 9999').optional(),
    note: z.string().trim().max(500, 'Höchstens 500 Zeichen').optional().transform((v) => (v ? v : undefined)),
})
    .strict()
    .superRefine((v, ctx) => {
    if (v.kind !== 'note' && v.quantity === undefined)
        ctx.addIssue({ code: 'custom', path: ['quantity'], message: v.kind === 'extra_km' ? 'Bitte die zusätzlichen Kilometer angeben' : 'Bitte die Wartezeit in Minuten angeben' });
    if (v.kind === 'note' && (!v.note || v.note.length < 3))
        ctx.addIssue({ code: 'custom', path: ['note'], message: 'Bitte schreiben Sie die Notiz' });
});
//# sourceMappingURL=ride-reports.js.map